<template>
  <v-card class="pa-sm-8 pa-2">
    <btn-close-dialog
      v-if="isSolicitanteNovo"
      :handle-click="closeDialog"
    />

    <v-row>
      <v-col
        cols="12"
        class="py-0"
      >
        <h2 class="text-center justify-center mb-4 mt-4">
          {{ isSolicitanteNovo ? 'CADASTRO CLIENTE' : 'EDITAR CLIENTE' }}
        </h2>
      </v-col>

      <v-col
        cols="12"
        class="py-0"
      >
        <v-divider class="mx-5"></v-divider>
      </v-col>
    </v-row>

    <v-card-text class="mt-5">
      <v-form
        ref="formRef"
        class="multi-col-validation"
        @submit.prevent="handleSubmit"
      >
        <v-row>
          <v-col
            cols="12"
            class="pt-0"
          >
            <h3 class="start">
              Dados Pessoais
            </h3>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model.trim="solicitanteData.nome"
              dense
              outlined
              label="Nome *"
              hide-details="auto"
              validate-on-blur
              :rules="[validators.required]"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-for="(contato, index) in solicitanteData.contatos"
            :key="contato.id"
            class="pt-0 d-flex align-center"
            cols="12"
          >
            <v-text-field
              v-model.trim="contato.email"
              dense
              outlined
              label="Email *"
              hide-details="auto"
              validate-on-blur
              class="mr-2"
            />

            <v-text-field
              v-model.trim="contato.celular"
              v-mask="'(##) #####-####'"
              dense
              outlined
              label="Celular *"
              hide-details="auto"
              validate-on-blur
            />

            <div
              v-if="index === 0"
              class="d-flex flex-column"
            >
              <v-tooltip
                top
                color="primary"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    x-small
                    icon
                    v-on="on"
                    @click="adicionarCampo(solicitanteData.contatos)"
                  >
                    <v-icon>
                      {{ icons.mdiPlusThick }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Adicionar contato</span>
              </v-tooltip>
            </div>

            <div
              v-if="index > 0"
              class="d-flex flex-column"
            >
              <v-tooltip
                top
                color="primary"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    x-small
                    icon
                    v-on="on"
                    @click="removerCampo(solicitanteData.contatos, index)"
                  >
                    <v-icon>
                      {{ icons.mdiMinusThick }}
                    </v-icon>
                  </v-btn>
                </template>
                <span>Apagar este contato</span>
              </v-tooltip>
            </div>

            <v-chip>
              <v-icon
                left
                :color="colors(index)"
              >
                {{ icons.mdiContacts }}
              </v-icon>
              {{ `${index === 0 ? 'Principal' : indexParaOrdinal(index) }` }}
            </v-chip>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="7"
          >
            <v-text-field
              v-model.trim="solicitanteData.cpf"
              v-mask="'###.###.###-##'"
              dense
              outlined
              label="CPF"
              hide-details="auto"
              validate-on-blur
            />
          </v-col>

          <v-col
            cols="12"
            md="5"
          >
            <v-text-field
              v-model.trim="dataNascimento"
              v-mask="'##/##/####'"
              dense
              outlined
              label="Data de nascimento"
              hide-details="auto"
              validate-on-blur
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="7"
          >
            <v-text-field
              v-model.trim="solicitanteData.rg"
              v-mask="'##.###.###-#'"
              dense
              outlined
              label="RG"
              hide-details="auto"
              validate-on-blur
            />
          </v-col>

          <v-col
            cols="12"
            md="5"
          >
            <v-text-field
              v-model.trim="solicitanteData.orgaoEmissor"
              outlined
              dense
              label="Órgão emissor"
              hide-details="auto"
              validate-on-blur
            />
            <span class="d-flex justify-end mt-1 text-caption">* CAMPOS OBRIGATÓRIOS</span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-divider class="mb-4"></v-divider>
          </v-col>
        </v-row>

        <v-card
          class="mt-2"
          elevation="4"
          outlined
        >
          <v-card-title class="d-flex justify-space-between align-center pl-3 pb-2 pt-3">
            <span>Endereços</span>

            <v-tooltip
              top
              color="primary"
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  fab
                  x-small
                  v-on="on"
                  @click.stop="adicionarEndereco"
                >
                  <v-icon>
                    {{ icons.mdiPlusThick }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Adicionar endereço</span>
            </v-tooltip>
          </v-card-title>

          <v-divider></v-divider>

          <span
            v-if="!solicitanteData.enderecos.length"
            class="d-flex align-center justify-center pa-3"
          >
            Nenhum endereço cadastrado
          </span>

          <v-expansion-panels
            focusable
            :value="expansionPanelsQueDevemAbrir"
          >
            <solicitante-enderecos-expansion-panel
              v-for="(endereco, index) in solicitanteData.enderecos"
              :key="index"
              :index="index"
              :endereco="endereco"
              :atualizar-endereco="atualizarEndereco"
              :deletar-endereco="deletarEndereco"
            />
          </v-expansion-panels>
        </v-card>

        <v-row class="mt-4">
          <v-col
            cols="12"
            class="d-flex justify-center"
          >
            <v-btn
              color="primary"
              type="submit"
              :disabled="loading"
              class="mr-4"
            >
              <v-progress-circular
                v-if="loading"
                class="mx-3"
                indeterminate
                color="secundary"
              />
              <span v-else>Salvar</span>
            </v-btn>

            <v-btn
              color="secondary"
              outlined
              :disabled="loading"
              @click="resetDataAndCloseDialog"
            >
              Cancelar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from '@core/utils/validation'
import { ref, computed, watchEffect } from '@vue/composition-api'
import { mdiPlusThick, mdiMinusThick, mdiContacts } from '@mdi/js'
import SolicitanteEnderecosExpansionPanel from './SolicitanteEnderecosExpansionPanel.vue'
import BtnCloseDialog from '@/components/btn-close-dialog/BtnCloseDialog.vue'
import useDialog from '@/composables/useDialog'
import SolicitanteModel from '@/models/entities/solicitante/SolicitanteModel'
import ClienteService from '@/services/modules/ClienteService'
import { converterLocaleDateStringParaOFormatoIsoDateString, converterDateStringEmLocaleDateString } from '@/utils/dateTime'
import SolicitanteEnderecoModel from '@/models/entities/solicitante/SolicitanteEnderecoModel'

export default {
  components: {
    BtnCloseDialog,
    SolicitanteEnderecosExpansionPanel,
  },

  props: {
    solicitanteId: {
      type: Number,
      required: true,
    },
    closeDialog: {
      type: Function,
      required: true,
    },
  },

  setup(props, { emit }) {
    const isSolicitanteNovo = computed(() => props.solicitanteId === 0)

    const solicitanteData = ref(new SolicitanteModel())
    const dataNascimento = ref(null)

    const { formRef, loading, resetForm } = useDialog(emit, 'is-configurar-solicitante-dialog-open')

    async function getSolicitante() {
      try {
        loading.value = true
        solicitanteData.value = await ClienteService.getSolicitante(props.solicitanteId)
        dataNascimento.value = solicitanteData.value.dataNascimento ? converterDateStringEmLocaleDateString(solicitanteData.value.dataNascimento) : null
      } finally {
        loading.value = false
      }
    }
    watchEffect(() => { if (props.solicitanteId) { getSolicitante() } })

    function resetData() {
      resetForm()
      solicitanteData.value = new SolicitanteModel()
      dataNascimento.value = null
    }

    function resetDataAndCloseDialog() {
      resetData()
      props.closeDialog()
    }

    function getClienteRequestBody() {
      return { ...solicitanteData.value, dataNascimento: converterLocaleDateStringParaOFormatoIsoDateString(dataNascimento.value) }
    }

    async function createCliente() {
      try {
        loading.value = true
        await ClienteService.createSolicitante(getClienteRequestBody())
        emit('refetch-data')
        resetDataAndCloseDialog()
      } finally {
        loading.value = false
      }
    }

    async function updateCliente() {
      try {
        loading.value = true
        await ClienteService.updateSolicitante(props.solicitanteId, getClienteRequestBody())
        emit('refetch-data')
        resetDataAndCloseDialog()
      } finally {
        loading.value = false
      }
    }

    async function handleSubmit() {
      if (loading.value) return
      if (formRef.value.validate()) {
        if (isSolicitanteNovo.value) {
          await createCliente()
        } else {
          await updateCliente()
        }
      }
    }

    const expansionPanelsQueDevemAbrir = ref([])

    function adicionarEndereco() {
      if (!expansionPanelsQueDevemAbrir.value.includes(0)) {
        expansionPanelsQueDevemAbrir.value.push(0)
      }
      solicitanteData.value.enderecos.push(new SolicitanteEnderecoModel())
    }

    function atualizarEndereco(index, endereco) {
      solicitanteData.value.enderecos[index] = endereco
    }

    function deletarEndereco(index) {
      solicitanteData.value.enderecos.splice(index, 1)
    }

    function adicionarCampo(item) {
      item.push({})
    }

    function removerCampo(item, index) {
      if (item.length > 1) {
        item.splice(index, 1)
      }
    }

    const colors = value => {
      if (value === 0) return 'primary'
      if (value === 1) return 'accent'
      if (value === 2) return 'success'
      if (value === 3) return 'error'
      if (value === 4) return 'warning'
      if (value === 5) return 'secundary'

      return 'success'
    }

    function indexParaOrdinal(contador) {
      const ordinais = {
        1: 'Segundo',
        2: 'Terceiro',
        3: 'Quarto',
        4: 'Quinto',
        5: 'Sexto',
        6: 'Sétimo',
        7: 'Oitavo',
        8: 'Nono',
        9: 'Décimo',
      }

      return `${ordinais[contador % 10]}`
    }

    return {
      isSolicitanteNovo,
      solicitanteData,
      dataNascimento,
      formRef,
      loading,
      colors,
      indexParaOrdinal,
      adicionarCampo,
      removerCampo,
      resetDataAndCloseDialog,
      handleSubmit,
      expansionPanelsQueDevemAbrir,
      adicionarEndereco,
      atualizarEndereco,
      deletarEndereco,
      validators: { required },
      icons: { mdiPlusThick, mdiMinusThick, mdiContacts },
    }
  },
}
</script>
